import { MCurrentVersion } from "./current-version.model";
import { ModuleEvaluation } from "../interfaces/Organization";
import { MSubversion } from "./subversion.model";
import { MSource } from "./source-taker.model";

export class MModuleEvaluation {
  public id: number;
  public startDate: string;
  public finishDate: string;
  public result: string;
  public status: string;
  public subversion: MSubversion;
  public sourcesAndTakers: MSource[] = [];
  public score: number;
  public requirementNonconforming: number;

  constructor(evaluation: ModuleEvaluation) {
    this.id = evaluation.id;
    this.startDate = evaluation.fecha_apertura;
    this.finishDate = evaluation.fecha_cierre;
    this.result = evaluation.resultado;
    this.status = evaluation.estatus;
    this.subversion = new MSubversion(evaluation.subversion_modulo);
    evaluation.fuente_tomadores.forEach(src => {
      this.sourcesAndTakers.push(new MSource(src));
    });
    this.requirementNonconforming = evaluation.req_no_conformes;
    // console.log(evaluation.puntaje)
    this.score = evaluation.puntaje === null ? 0 : +evaluation.puntaje.toFixed(2);
  }
}
